import React from 'react'
import type { DataGovernor } from '../../../../api/client'
import type { Notice } from '../DataGovernorsPage.logic'
import type { useStyles } from '../DataGovernorsPage.style'
import { RegistryFeedback } from '../RegistryFeedback/RegistryFeedback'
import { RegistryTable } from '../RegistryTable/RegistryTable'

export interface AssignmentRegistryCardProps {
  readonly classes: ReturnType<typeof useStyles>['classes']
  readonly filteredGovernors: readonly DataGovernor[]
  readonly hubFriendlyNames: Readonly<Record<string, string>>
  readonly isLoading: boolean
  readonly hasLoaded: boolean
  readonly error: string | null
  readonly onDismissError: () => void
  readonly notice: Notice | null
  readonly onDismissNotice: () => void
  readonly onRemoveRequested: (governor: DataGovernor) => void
}

export const AssignmentRegistryCard: React.FC<AssignmentRegistryCardProps> = ({
  classes,
  filteredGovernors,
  hubFriendlyNames,
  isLoading,
  hasLoaded,
  error,
  onDismissError,
  notice,
  onDismissNotice,
  onRemoveRequested,
}) => (
  <>
    <RegistryFeedback
      classes={classes}
      error={error}
      onDismissError={onDismissError}
      notice={notice}
      onDismissNotice={onDismissNotice}
      isLoading={isLoading}
      hasLoaded={hasLoaded}
    />

    {!error && (
      <RegistryTable
        classes={classes}
        filteredGovernors={filteredGovernors}
        hubFriendlyNames={hubFriendlyNames}
        isLoading={isLoading}
        onRemoveRequested={onRemoveRequested}
      />
    )}
  </>
)
